"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var useWindowSize_1 = require("../useWindowSize");
exports.useIsMobile = function (mobilePxBreakpoint) {
    var width = useWindowSize_1.useWindowSize().width;
    var breakpoint = mobilePxBreakpoint ? mobilePxBreakpoint : 992;
    return width && width < breakpoint ? true : false;
};
//# sourceMappingURL=index.js.map